module.exports = __webpack_public_path__ + "img/beta-unsplash-03.4b88ac71.jpg";